import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { environment } from 'src/environments/environment';

import { HappinessItem } from 'src/models/happiness-item.model';

const ENDPOINT = `${environment.api_url}api/v1/customer/happiness-items`;

@Injectable({
  providedIn: 'root'
})
export class HappinessItemsService {

  private http = inject(HttpClient);

  async getHappinessItems(addressId?: number): Promise<HappinessItem[]> {
    let params = new HttpParams();
    if (addressId) {
      params = params.set('address_id', addressId);
    }
    return firstValueFrom(
      this.http.get<HappinessItem[]>(ENDPOINT, { params })
    );
  }

  async createHappinessItem(payload: Record<string, any>): Promise<HappinessItem> {
    return firstValueFrom(
      this.http.post<HappinessItem>(ENDPOINT, payload)
    );
  }

  async updateHappinessItem(id: number, payload: Record<string, any>): Promise<HappinessItem> {
    return firstValueFrom(
      this.http.put<HappinessItem>(`${ENDPOINT}/${id}`, payload)
    );
  }

  async deleteHappinessItem(id: number): Promise<void> {
    return firstValueFrom(
      this.http.delete<void>(`${ENDPOINT}/${id}`)
    );
  }
}
